
    <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="text" [tooltipPosition]="position"></app-icon>
  